import { t } from 'src/i18n';
import type { PersonalDataItemViewModelExtended } from './personal-data-item-view-model-extended';
import { isEmptyText } from './is-empty-text';
import { isEmpty } from './is-empty';

export function alertsForDataItem(c: PersonalDataItemViewModelExtended): string[] {
  const warnings: string[] = [];
  if (!c.riskAssessmentConcludesOk && c.personalData) {
    warnings.push(t('computers.alertNotRiskAssessed'));
  }
  if (
    c.storageMedium === 'digital' &&
    c.treatments.indexOf('storage') > -1 &&
    (c.backupOperatorType === 'NONE' || c.backupOperatorType === 'UNDEFINED')
  ) {
    if (
      c.storageUnitComputer &&
      (c.storageUnitComputer.unitType === 'cloudService' || c.storageUnitComputer.unitType === 'remoteServer')
    ) {
      // do nothing
    } else {
      warnings.push(t('computers.alertBackupNotDefined'));
    }
  }
  if (c.backupOperatorType === 'external' && (c.backupOperator == null || c.backupOperator.length < 1)) {
    warnings.push(t('computers.alertBackupSupplierNotDefined'));
  }
  if (!c.patientDialogueRequirements) {
    c.patientDialogueRequirements = [];
  }
  if (c.type === 'patientDialogue' && c.patientDialogueRequirements.length < 1) {
    warnings.push(t('computers.alertSupportToolRequirementsNotMet'));
  }
  const missingFields: string[] = [];
  if (!c.type || c.type === 'UNDEFINED') {
    missingFields.push(t('computers.missingField.type'));
  }
  if (c.type === 'medicalRecords' && c.storageMedium === 'digital') {
    if (!c.journalSize) {
      missingFields.push(t('computers.missingField.numberOfPatients'));
    }
    if (c.journalHasElectronicMessaging === true) {
      if (!c.messagingType || c.messagingType === 'UNDEFINED') {
        missingFields.push(t('computers.missingField.communicationModule'));
      }

      if (c.messagingSupplier === null || c.messagingSupplier === '') {
        missingFields.push(t('computers.missingField.communicationModuleSupplier'));
      }
    }
  }
  if (c.personalData || c.type?.startsWith('patientData')) {
    if (isEmptyText(c.purpose)) {
      missingFields.push(t('computers.missingField.purpose'));
    }
    if (c.type === 'medicalRecords' && isEmptyText(c.legalBasis)) {
      missingFields.push(t('computers.missingField.legalBasis'));
    }
    if (c.type != 'medicalRecords' && isEmptyText(c.legalBasis) && isEmpty(c.consentContracts)) {
      missingFields.push(t('computers.missingField.legalBasisOrConsent'));
    }
  }

  if (missingFields.length > 0) {
    warnings.push(t('computers.alertNotRegistered', { fields: missingFields.join(', ') }));
  }
  return warnings;
}
